import { useTranslate } from "@/hooks/use-translate/useTranslate";

import type { IQuestion } from "@/types/types";
import Question from "./questions/Question";

interface QuestionsColumnProps {
  questions: IQuestion[];
}

const QuestionsColumn = ({ questions = [] }: QuestionsColumnProps) => {
  const translate = useTranslate();

  return (
    <div className="grow mr-6 py-4 flex flex-col gap-y-4">
      <div className="text-ib-main font-ib-bold text-ib-gray-darksest">
        {translate("actionToDo")}
      </div>
      <>
        {questions.map((question, index) => (
          <Question
            key={`question-${question.questionId}`}
            num={index + 1}
            question={question}
          />
        ))}
      </>
    </div>
  );
};

export default QuestionsColumn;
